<div class="app-error-with-refresh-container">
  <div
    class="error"
    [innerHTML]="error"
  ></div>
  <button
    color="accent"
    class="refresh-button"
    mat-flat-button
    (click)="onRefreshClick()"
  >
    <span class="refresh-button-text">Refresh</span>
  </button>
</div>
